'use client';

import Script from 'next/script';

import { cn } from '@lib';

export interface SodaAttributes {
  brands: string;
  containerId?: string;
  className?: string;
}

export const SodaWidget = ({ brands, containerId, className }: SodaAttributes) => {
  const appendScript = () => {
    const containerElement = document.getElementById(containerId || 'soda-container');
    if (!containerElement) return;

    // Move script output to the desired container after it loads
    const script = document.getElementById('sodaPartnerWidget');
    const footer = document.querySelector('.soda-footer__powered-by');

    if (script) {
      containerElement.appendChild(script);
      // remove footer
      if (footer) {
        footer.remove();
      }
    }
  };

  return (
    <>
      <div id={containerId || 'soda-container'} className={cn('w-full', className)} />

      <Script
        strategy="lazyOnload"
        soda-partner-widget
        src={`https://widgets.designmynight.com/soda/soda-widget.min.js?brands=${brands}&skip-list=false`}
        onLoad={() => {
          appendScript();
          console.log('Script loaded successfully');
        }}
        onError={() => console.error('Failed to load the script')}
      />
    </>
  );
};
